import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth-service';

@Injectable({
  providedIn: 'root'
})
export class SysadminGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkSysadminRole();
  }

  private checkSysadminRole(): Observable<boolean | UrlTree> {
    if (this.authService.keycloakActive && this.authService.keycloak) {
      const isSysadmin = this.authService.keycloak.isUserInRole('sysadmin');
      const isSuperMario =
        this.authService.keycloak.isUserInRole('super_mario');

      if (isSysadmin || isSuperMario) {
        return of(true);
      }

      return of(this.router.parseUrl('/'));
    } else if (this.authService.cas) {
      return forkJoin([
        this.authService.cas.isUserInRole('sysadmin'),
        this.authService.cas.isUserInRole('super_mario')
      ]).pipe(
        map(([isSysadmin, isSuperMario]) => {
          if (isSysadmin || isSuperMario) {
            return true;
          }
          return this.router.parseUrl('/');
        }),
        catchError(() => {
          return of(this.router.parseUrl('/'));
        })
      );
    }

    return of(this.router.parseUrl('/'));
  }
}
